// components/EmailConnection.jsx
import { useState, useEffect } from 'react';

import LayoutAdmin from "../components/LayoutAdmin";
import axiosExt from '../axios';
import { API_BASE_URL } from "../config.ts"

import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    Stack,
    List,
    ListItem,
    ListItemText,
    Button,
} from "@mui/material";

interface EmailSubscriptionStatus {
    changeType: string;
    expiresAt: string; // ISO string from backend
    active: boolean;
}

interface EmailConnectionStatus {
    connected: boolean;
    email: string;
    displayName: string;
    connectedAt: string; // ISO string
    subscriptions: EmailSubscriptionStatus[];
}

//const EmailListPage: React.FC = () =>
const EmailConnectionPage: React.FC = () => {
    const [status, setStatus] = useState<EmailConnectionStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  useEffect(() => {
    loadStatus();
  }, []);

  const loadStatus = async () => {
    try {
     const res = await axiosExt.get(`${API_BASE_URL}/email-connection/status`, {
                headers: { Authorization: `Bearer ${token}` },
            });

      const data = await res.data;
      setStatus(data);
    } catch (error) {
      console.error('Failed to load status', error);
    } finally {
      setLoading(false);
    }
  };

  const connect = async () => {
    try {
      const res = await axiosExt.get(`${API_BASE_URL}/email-connection/start`, {
                headers: { Authorization: `Bearer ${token}` },
            });

      const data = await res.data;
      window.location.href = data.url;  // Redirect to Microsoft
    } catch (error) {
      alert('Failed to start connection');
    }
  };

  const disconnect = async () => {
    if (!confirm('Are you sure you want to disconnect the email account?')) {
      return;
    }

    try {
        await axiosExt.delete(`${API_BASE_URL}/email-connection/disconnect`, {
        headers: { Authorization: `Bearer ${token}` },
    });

      loadStatus();
    } catch (error) {
      alert('Failed to disconnect');
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!status?.connected) {
    return (
      <div className="email-connection">
        <h2>Connect Email Account</h2>
        <p>Connect a Microsoft 365 email account to sync emails.</p>
        <button onClick={connect} className="btn btn-primary">
          Connect Microsoft 365
        </button>
      </div>
    );
  }

    return (
        <LayoutAdmin>
            <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
                <Card elevation={3}>
                    <CardContent>
                        <Typography variant="h5" gutterBottom>
                            Connected Email Account
                        </Typography>

                        <Divider sx={{ mb: 2 }} />

                        <Stack spacing={1}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {status.displayName}
                            </Typography>

                            <Typography variant="body1">
                                {status.email}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Connected:{" "}
                                {new Date(status.connectedAt).toLocaleString()}
                            </Typography>
                        </Stack>

                        <Box sx={{ mt: 3 }}>
                            <Typography variant="h6" gutterBottom>
                                Active Subscriptions
                            </Typography>

                            <List dense>
                                {status.subscriptions.map((sub, i) => (
                                    <ListItem key={i} disablePadding>
                                        <ListItemText
                                            primary={`${sub.changeType}: ${sub.active ? "Active" : "Expired"
                                                }`}
                                            secondary={`Expires: ${new Date(
                                                sub.expiresAt
                                            ).toLocaleString()}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>

                        <Box sx={{ mt: 3, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={disconnect}
                            >
                                Disconnect
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </LayoutAdmin>
    );
}

export default EmailConnectionPage;
